// frontend/src/pages/student/AssignmentDetailPage.js (نسخه اصلاح شده)

import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
// ✅ FIX: Corrected import paths (مفروض: اینها در پروژه شما تعریف شده‌اند)
import { API_BASE_URL, getAuthHeaders } from '../../modules/api'; 
import { FaBook, FaCalendarAlt, FaPaperclip, FaUpload, FaSpinner, FaArrowLeft } from 'react-icons/fa';
import StudentHeader from '../../components/layout/StudentHeader';
import '../../assets/styles/global.css';

// ---------------------------------------------------------------------
// ✅ اصلاح ساختاری: کامپوننت باید قبل از export تعریف شود. 
// حذف 'export default AssignmentDetailPage;' از بالای فایل
// ---------------------------------------------------------------------

const AssignmentDetailPage = () => {
    const { assignmentId } = useParams(); // خواندن ID تکلیف از URL
    const [assignment, setAssignment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // State برای فرم ارسال پاسخ
    const [submissionContent, setSubmissionContent] = useState('');
    const [submissionFile, setSubmissionFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    useEffect(() => {
        const fetchAssignment = async () => {
            try {
                // فرض بر این است که assignmentId یک پارامتر معتبر است
                if (!assignmentId) {
                    setError('شناسه تکلیف نامعتبر است.');
                    setLoading(false);
                    return;
                }
                const response = await axios.get(`${API_BASE_URL}/core/assignments/${assignmentId}/`, getAuthHeaders());
                setAssignment(response.data);
            } catch (err) {
                console.error("Error fetching assignment:", err);
                setError('خطا در دریافت جزئیات تکلیف. ممکن است دسترسی نداشته باشید.');
            } finally {
                setLoading(false);
            }
        };
        fetchAssignment();
    }, [assignmentId]);

    const handleFileChange = (e) => {
        setSubmissionFile(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError(null);

        // اعتبارسنجی ساده
        if (!submissionContent && !submissionFile) {
            setError('لطفاً پاسخ متنی یا یک فایل برای ارسال ضمیمه کنید.');
            setIsSubmitting(false);
            return;
        }

        const formData = new FormData();
        formData.append('content', submissionContent);
        if (submissionFile) {
            formData.append('file', submissionFile);
        }

        try {
            // Special headers for multipart/form-data
            const authHeaders = getAuthHeaders().headers;
            delete authHeaders['Content-Type']; // Let axios set it for FormData (ضروری برای FormData)

            await axios.post(`${API_BASE_URL}/core/assignments/${assignmentId}/submit/`, formData, {
                headers: authHeaders,
            });
            setSubmitSuccess(true);
            setSubmissionContent(''); // پاک کردن فرم پس از موفقیت
            setSubmissionFile(null);
        } catch (err) {
            console.error("Submission Error:", err);
            if (err.response && err.response.data && err.response.data.detail) {
                 setError(err.response.data.detail);
            } else {
                setError('خطا در ارسال پاسخ. لطفاً دوباره تلاش کنید.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    // کامپوننت رندرینگ
    if (loading) return (
        <div className="text-center p-5 app-layout-student">
            <FaSpinner className="spinner text-indigo-600 text-3xl mx-auto block mb-2" /> 
            <p className="text-gray-600">در حال بارگذاری...</p>
        </div>
    );

    return (
        <div className="app-layout-student">
            <StudentHeader />
            <div className="page-content">
                <Link to="/student/dashboard" className="button button-secondary mb-6"><FaArrowLeft /> بازگشت به داشبورد</Link>
                
                {error && <div className="alert alert-danger">{error}</div>}
                
                {!assignment && !error ? (
                    <div className="alert alert-danger">تکلیف مورد نظر یافت نشد.</div>
                ) : assignment ? (
                    <>
                        {/* جزئیات تکلیف */}
                        <div className="form-card mb-6 shadow-lg border-t-4 border-indigo-600">
                            <div className="form-header bg-indigo-500 text-white">
                                <FaBook className="header-icon" />
                                <div>
                                    <h1 className="text-2xl font-bold">{assignment.title}</h1>
                                    <p className="text-sm flex items-center mt-1">
                                        <FaCalendarAlt className="ml-1" />
                                        مهلت ارسال: {new Date(assignment.due_date).toLocaleString('fa-IR', {year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'})}
                                    </p>
                                </div>
                            </div>
                            <div className="form-body p-6">
                                <h3 className="text-lg font-semibold mb-3 border-b pb-2 text-gray-700">توضیحات</h3>
                                <div className="prose max-w-none text-gray-600" dangerouslySetInnerHTML={{ __html: assignment.content }} />
                                {/* اینجا می‌توانید نمره و وضعیت ارسال قبلی را نمایش دهید */}
                            </div>
                        </div>

                        {/* بخش ارسال پاسخ */}
                        {submitSuccess ? (
                            <div className="alert alert-success mt-6 shadow-md">
                                پاسخ شما با موفقیت ثبت شد و در انتظار تصحیح معلم است.
                            </div>
                        ) : (
                            <div className="form-card shadow-lg">
                                <div className="form-header bg-gray-600 text-white">
                                    <h3><FaUpload /> ارسال پاسخ</h3>
                                </div>
                                <form className="form-body p-6" onSubmit={handleSubmit}>
                                    <div className="form-group mb-4">
                                        <label className="block text-sm font-medium text-gray-700 mb-2">پاسخ متنی (اختیاری)</label>
                                        <textarea 
                                            rows="5" 
                                            className="w-full border border-gray-300 rounded-lg p-3 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                            value={submissionContent} 
                                            onChange={(e) => setSubmissionContent(e.target.value)} 
                                            placeholder="پاسخ خود را اینجا تایپ کنید یا اگر فایل ضمیمه می‌کنید، توضیح مختصری بنویسید..."
                                        ></textarea>
                                    </div>
                                    <div className="form-group mb-6">
                                        <label className="block text-sm font-medium text-gray-700 mb-2"><FaPaperclip className="inline ml-1" /> ضمیمه فایل (اختیاری)</label>
                                        <input 
                                            type="file" 
                                            onChange={handleFileChange} 
                                            className="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                                        />
                                        {submissionFile && <p className="mt-2 text-sm text-gray-500">فایل انتخابی: {submissionFile.name}</p>}
                                    </div>
                                    <button 
                                        type="submit" 
                                        className="button button-primary w-full py-3 flex justify-center items-center text-lg" 
                                        disabled={isSubmitting || loading}
                                    >
                                        {isSubmitting ? <FaSpinner className="animate-spin ml-2" /> : <FaUpload className="ml-2" />}
                                        {isSubmitting ? 'در حال ارسال پاسخ...' : 'ثبت نهایی پاسخ'}
                                    </button>
                                </form>
                            </div>
                        )}
                    </>
                ) : null}
            </div>
        </div>
    );
};

export default AssignmentDetailPage;
